import React, { useEffect, useState, useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import Dropdown from 'react-bootstrap/Dropdown';
import { useNavigate } from "react-router";
import "../assets/css/style.css";
import eyeoff from "../assets/img/logo2 1.png"
import mobillogo from "../assets/img/mobile-logo.png"
import search from "../assets/img/sreach---icon.svg"
import bell from "../assets/img/bell.svg"
import chat from "../assets/img/chat.svg"
import bttnicon from "../assets/img/creat-post.svg"
import userImg from "../assets/img/user 1.svg"
import searchwhite from "../assets/img/header/search.svg"
import call from "../assets/img/header/contactdrp.png"
import faqIcon from "../assets/img/header/faqdrp.png"
import CreatePost from "../views/Posts/CreatePost";
import "../assets/css/header.css"
import profileimgs from "../assets/img/profile/profile-img.svg"
import TourIcon from "../assets/icons/TourIcon.svg"
import HeaderSearch from "./HeaderSearch";
import Notification from "./Notification";
import Cookies from 'js-cookie';
import { UserContext } from "../config/userContext";
import { getUserNotifications } from "../services/apiOtherlink";
import { getUsersSearch } from "../services/apiOtherlink";
import ChangePassword from "../views/authentication/ChangePassword";
import { API } from "../services/api";
import GuidedTourPopUp from "../views/OtherLinks/GuidedTourPopUp";
const Header = ({ toggleSidebar }) => {
  const Group = require("../assets/img/Featured icon.jpg");
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [guidedTouropen, setGuidedTourOpen] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [userId, setUserId] = useState('');
  const [hasUserSearch, sethasUserSearch] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('post');
  const [UsersArr, setUsersArr] = useState([]);
  const [isChangePsw, setIsChangePsw] = useState(false);
  const [isNotif, setIsNotif] = useState(false);
  const [notifArr, setNotifArr] = useState([]);
  const user = JSON.parse(localStorage.getItem('userData'));
  const handleSearchClose = () => setIsSearch(false);
  const handleChangePswClose = () => setIsChangePsw(false);
  const { userData } = useContext(UserContext);
   const profileImg = userData?.profileImage?.url;
  const OpenPopup = () => {
    setOpen(true);
  }
  const ClosePopup = () => {
    setOpen(false);
  }
  const GuidedTourOpenPopup = () => {
    setGuidedTourOpen(true);
  }
  const GuidedTourClosePopup = () => {
    setGuidedTourOpen(false);

  }

  useEffect(() => {
    setUserId(user._id)
    getAllNotification()
  }, [])

  const getAllNotification = async () => {
    const user = JSON.parse(localStorage.getItem('userData'));
    const formData = {
      userid: user._id,
      offset: 0,
      limit: 20
    }
    let allNotification = await getUserNotifications(formData);
    setNotifArr(allNotification.notifications)

  };

  const getAllUsersForSearch = async (searchQry) => {
    const user = JSON.parse(localStorage.getItem('userData'));
    const formData = {
      userid: user._id,
      searchkey: searchQry
    }
    let allUsers = await getUsersSearch(formData);
    setUsersArr(allUsers.users)
  };

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = () => {
  if (searchQuery.trim()) {
    if(selectedCategory === 'post')
    {
    sethasUserSearch(false);
    navigate(`/SearchPost?search=${encodeURIComponent(searchQuery.trim())}`);
    
    }
    else{
    sethasUserSearch(true);
    getAllUsersForSearch(searchQuery.trim());
    }
  }
  else
  {
        sethasUserSearch(false);

  }
    
};




const handleChangeSearch = (val) => {

  if (val.trim()) {
    if(selectedCategory === 'user')
    {
    setTimeout(() => {
    getAllUsersForSearch(val.trim());
            }, 500);
                sethasUserSearch(true);

    }
  }
  else
  {
        sethasUserSearch(false);
  }
};


const handleKeyDown = (e) => {
  if (e.key === 'Enter') {
    handleSearch();
  }
};

  const handleSelectedCategoryChange = (e) => {
        setSelectedCategory(e.target.value);
        setSearchQuery('');

    };
    const slugify = (text = "") =>
  text
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-")
    .replace(/[^a-z0-9-]/g, "");


  const handleImageClick = (first, last, id) => {
   const userName = `${slugify(first)}-${slugify(last)}`;
  navigate(`/profile/${userName}`, { state: { userId: id } })
  //setSearchQuery('');
  sethasUserSearch(false);
  };

  return (
    // <header className="head-over">
    <>
      <header className="header-top container-fluid d-flex align-items-center justify-content-between">

        <div class="d-flex align-items-center header_logos">
          <button className="btn toggle-btn d-lg-none header-toggle" onClick={toggleSidebar}>
            &#9776;
          </button>
          <span class="h5 mb-0">
            <img src={eyeoff} alt="Logo comp-logo" class="heder-logo me-3" />
          </span>
          <span class="h5 mb-0">
            <img src={mobillogo} alt="Mobile Logo" className="mobile-logo" />
          </span>

        </div>
        <form className="d-flex mx-auto search-input-header" onSubmit={(e) => {
  e.preventDefault();
  handleSearch();
}}>
  <div className="input-group search-header-wrapper header_search">
    <span className="input-group-text bg-white mobil-view-class border-end-0">
      <img src={search} alt="search--Logo" className="search-logo-header mob-view-class" />
    </span>
    <input
      type="search"
      className="form-control border-start-0 search-inputs"
      placeholder="Search..."
      aria-label="Search"
      value={searchQuery}
      onChange={(e) => {
        e.preventDefault();
        setSearchQuery(e.target.value);
         handleChangeSearch(e.target.value);
      }}
      autoComplete="off"
      onKeyDown={handleKeyDown}
    />
                
                <div className="searchSelect">
                  <select className="arwCust" value={selectedCategory} onChange={handleSelectedCategoryChange}>
                      <option value="post">Post</option>
                      <option value="user">User</option>
                  </select>
                  <i class="fa fa-angle-down select-icon"></i>
                </div>

            {hasUserSearch && (
                    <div className="searchlist">
                     {UsersArr.length > 0  && (
                      <div>
                     <ul className="drop-div-join list-group  mt-1 responsive-dropdown">
                      {UsersArr.map((item, index) => (
                        <li key={index} className="list-group-item d-flex align-items-center">
                          <img
                           src={item.profileImage?.url
                          ? API.uploadFilePath + item.profileImage?.url
                          : profileimgs}
                           alt="test"
                          className="community_thumb" onClick={() => {
                           handleImageClick(item.firstName,item.lastName,item._id);
                        }}    
                />
                <span className="w-100 mb-1" onClick={() => {
                           handleImageClick(item.firstName,item.lastName,item._id);
                        }}>{item.firstName + " " + item.lastName}</span>
                        </li>
                  ))}
                    </ul>
                    </div>
                 )}
                   <div>
                  {UsersArr.length === 0 && (
                     <ul className="Favorites-div d-flex justify-content-between align-items-center community-card p-2">
                        <li className="d-flex align-items-center gap-2">
                       <span className="letter-width text-truncate">No Users found!</span>
                        </li>
                      </ul>
                 )}
                 
                    </div>
                  
              </div>)}
  </div>


  
</form>




        <div class="d-flex align-items-center header-actions">
          <button className="btn chat-bbtn message-dh d-none search" onClick={() => setIsSearch(true)}>
            <img src={searchwhite} className="chat-icon" alt="chat Icon" />
          </button>

           

          <button className="btn chat-bbtn message-dh"
            onClick={() => navigate('/message')}
          >
            <img src={chat} className="chat-icon" alt="chat Icon" />
          </button>

          <div class="notification-wrapper">
            <button className="btn chat-bbtn notification-dh" onClick={() => setIsNotif(true)}>
              <img src={bell} className="bell-icon" alt="bell Icon" />
            </button>
            <span class="notification-badge">{notifArr.length}</span>
          </div>

          <button className="btn creat-bttn create-dh create_postbt" onClick={OpenPopup}>
            <img src={bttnicon} className="creat-icon" alt="Create Icon" /><span>Create Post</span>
          </button>


          <Dropdown className="user-dropdown" >
            <Dropdown.Toggle className="drp-btn" variant="success" id="dropdown-basic">
                <img src={userData?.profileImage?.url ? API.uploadFilePath+userData?.profileImage?.url : userImg} className="avar-logoss user-icon user-dh" alt="User"
                  title="user"  />
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => {
                if (userData && userData.userType !== 'organization') {
                  navigate('/profile');
                } else {
                  navigate('/organization');
                }
              }}><i class="bi bi-person"></i><span>Profile</span></Dropdown.Item>
               <Dropdown.Item onClick={() => navigate('/faq')}><img src={faqIcon} className="drpw-icon" alt="chat Icon" /><span>FAQ</span></Dropdown.Item>
              <Dropdown.Item onClick={() => navigate('/contact-us')}><img src={call} className="drpw-icon" alt="chat Icon" /><span>Contact Us</span></Dropdown.Item>
              <Dropdown.Item onClick={() => { setIsChangePsw(true) }}><i class="bi bi-key"></i><span>Change Password</span></Dropdown.Item>
              <Dropdown.Item onClick={() => { setGuidedTourOpen(true) }}><img src={TourIcon} className="drpw-icon mod-icon black guided-tour-icon" alt="chat Icon" /><span>Guided Tour</span></Dropdown.Item>
              <Dropdown.Item  onClick={() => { localStorage.clear(); Cookies.remove('authToken'); sessionStorage.removeItem('authToken'); 
                navigate('/');
              }}
                ><i class="bi bi-box-arrow-left"></i><span>Logout</span></Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

        </div>
        {/* </header> */}




      </header>
      <HeaderSearch isSearch={isSearch} handleClose={handleSearchClose} />
      <ChangePassword isChangePsw={isChangePsw} handleClose={handleChangePswClose} />
      <CreatePost openPop={open} closePop={ClosePopup}></CreatePost>
      <GuidedTourPopUp guidedTouropen={guidedTouropen} GuidedTourClosePopup={GuidedTourClosePopup}/>
      <Notification
        placement="end"
        name="end"
        show={isNotif}
        onClose={() => setIsNotif(false)}
        onCountUpdate={getAllNotification} 
      />
    </>


  );
};

export default Header;